var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 67,
    viewBox: "0 0 60 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10146_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21429 47.1138L3.69723 50.8676C1.71077 52.5184 1.56819 55.5177 3.38909 57.3495L4.8595 58.8287C7.99328 61.9813 12.7011 63.0143 16.8769 61.4905V61.4905C35.5577 54.6736 50.4388 39.9841 57.4048 21.3584V21.3584C58.9816 17.1421 57.9158 12.3924 54.6887 9.25413L52.8392 7.45562C50.9227 5.59193 47.825 5.75514 46.115 7.8099L39.9651 15.1996C37.9603 17.6086 38.1166 21.1473 40.3262 23.37L41.7917 24.8444C42.4489 25.5055 42.6944 26.4719 42.4324 27.3665L40.978 32.3323C39.1088 38.7143 34.2767 43.8032 28 46V46",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02081 15.0208C12.6597 8.3819 23.4235 8.3819 30.0624 15.0208C36.7014 21.6597 36.7014 32.4235 30.0624 39.0624L20.8701 48.2548C19.308 49.8169 16.7753 49.8169 15.2132 48.2548L6.02081 39.0624C-0.618102 32.4235 -0.618101 21.6597 6.02081 15.0208Z",
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5416 21.5416C15.5792 18.5041 20.5041 18.5041 23.5416 21.5416C26.5792 24.5792 26.5792 29.5041 23.5416 32.5416C20.5041 35.5792 15.5792 35.5792 12.5416 32.5416C9.50406 29.5041 9.50406 24.5792 12.5416 21.5416Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10146_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.fdce8441580306c5a169fc5904495528.svg";
export { ForwardRef as ReactComponent };